import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectManufacturers, selectMakes, selectModels, selectVersions, selectEngines, selectFeatures, selectJobTemplates, selectJobTasks } from 'src/app/common/store/state/app.state';
import { CarRefItemCode } from 'src/app/public/car/constants/car-basic-data';
import { CarEngine } from 'src/app/public/car/models/car-engine.model';
import { CarFeature } from 'src/app/public/car/models/car-feature.model';
import { CarJobTask } from 'src/app/public/car/models/car-job-task.model';
import { CarJobTemplate } from 'src/app/public/car/models/car-job-template.model';
import { CarMake } from 'src/app/public/car/models/car-make.model';
import { CarManufacturer } from 'src/app/public/car/models/car-manufacturer.model';
import { CarModel } from 'src/app/public/car/models/car-model.model';
import { CarVersion } from 'src/app/public/car/models/car-version.model';


@Component({
    selector: 'app-admin-carrefs',
    templateUrl: './admin-carrefs.component.html',
    styleUrl: './admin-carrefs.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AdminCarRefsComponent implements OnInit{

  @Input() selected! : CarRefItemCode;
  
  manufs$: Observable<CarManufacturer[]>;
  makes$: Observable<CarMake[]>;
  models$: Observable<CarModel[]>;
  versions$: Observable<CarVersion[]>;
  engines$: Observable<CarEngine[]>;
  features$: Observable<CarFeature[]>;

  jobTemplates$: Observable<CarJobTemplate[]>;
  jobTasks$: Observable<CarJobTask[]>;

  CarRefItemCode = CarRefItemCode;

  constructor(
    private store: Store,
    private route: ActivatedRoute
  ){
    this.manufs$ = this.store.select(selectManufacturers);
    this.makes$ = this.store.select(selectMakes);
    this.models$ = this.store.select(selectModels);
    this.versions$ = this.store.select(selectVersions);
    this.engines$ = this.store.select(selectEngines);
    this.features$ = this.store.select(selectFeatures);

    this.jobTemplates$ = this.store.select(selectJobTemplates);
    this.jobTasks$ = this.store.select(selectJobTasks);
  }

  ngOnInit(): void {

      this.route.data.subscribe(
        data => {
          this.selected = data['selected'];
        }
      )
  }
}
